import * as React from 'react';

import a11yKeyPress from 'js/lib/a11yKeyPress';

import { Select, StyleSheet, color, css } from '@coursera/coursera-ui';

const styles = StyleSheet.create({
  customOption: {
    display: 'flex',
    alignItems: 'center',
    height: 36,
    padding: '0 1rem',
  },
  customOptionFocused: {
    cursor: 'pointer',
    background: color.bgGray,
  },
  customOptionSelected: {
    fontWeight: 'bold',
  },
  customLabel: {
    flex: 1,
  },
});

function customValueRenderer(option: $TSFixMe) {
  return <span>{option.label}</span>;
}

function customOptionRenderer({
  focusedOption,
  focusOption,
  key,
  style,
  selectValue,
  option,
  valueArray,
}: {
  focusedOption: {
    label: string;
    value: string | number;
  };
  focusOption: (x0: { label: string; value: string | number }) => {};
  key: number | string;
  style: any;
  selectValue: (x0: { label: string; value: string | number }) => {};
  option: {
    label: string;
    value: string | number;
  };
  valueArray: Array<string | number>;
}) {
  return (
    <div
      {...css(
        styles.customOption,
        // @ts-expect-error TSMIGRATION
        valueArray.indexOf(option) >= 0 && styles.customOptionSelected,
        option === focusedOption && styles.customOptionFocused
      )}
      onClick={() => selectValue(option)}
      onKeyPress={(event) => a11yKeyPress(event, () => selectValue(option))}
      onMouseOver={() => focusOption(option)}
      onFocus={() => focusOption(option)}
      style={style}
      key={key}
      role="button"
      tabIndex={0}
    >
      <span {...css(styles.customLabel)}>{option.label}</span>
    </div>
  );
}

type Props = {
  options: Array<{
    label: string;
    value: string | number;
  }>;
  currentUserId: string | number;
  onUserChange: (
    selectedOption: {
      label: string;
      value: string | number;
    },
    selectedIndex: number
  ) => void;
};

export default function TeamMemberSelector({ options, currentUserId, onUserChange }: Props): JSX.Element {
  return (
    <Select
      className="rc-TeamMemberSelector"
      valueRenderer={customValueRenderer}
      optionRenderer={customOptionRenderer}
      options={options}
      onChange={onUserChange}
      value={currentUserId}
    />
  );
}
